import { render, staticRenderFns } from "./multipleLimit-editor.vue?vue&type=template&id=07a6384c&scoped=true"
import script from "./multipleLimit-editor.vue?vue&type=script&lang=js"
export * from "./multipleLimit-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a6384c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a6384c')) {
      api.createRecord('07a6384c', component.options)
    } else {
      api.reload('07a6384c', component.options)
    }
    module.hot.accept("./multipleLimit-editor.vue?vue&type=template&id=07a6384c&scoped=true", function () {
      api.rerender('07a6384c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/multipleLimit-editor.vue"
export default component.exports